module.exports = __webpack_public_path__ + "img/slider-disabled.6e42edf6.svg";